import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const defaultMemberBalanceDisplayText = {
    availableUnitsFormat: '${availableUnits}',
    monetaryValueFormat: '${monetaryValue|c}',
    expiringUnitsFormat: '${expiringUnits} expire on ${expiresAt|d|D/MM/YYYY}',
    primaryValueFormat: '${primaryValue}',
    secondaryValueFormat: '${secondaryValue}'
};
export const memberBalanceDisplayTextValidator = Validator.object({
    availableUnitsFormat: nonEmptyStringValidator,
    monetaryValueFormat: nonEmptyStringValidator,
    expiringUnitsFormat: nonEmptyStringValidator,
    primaryValueFormat: nonEmptyStringValidator,
    secondaryValueFormat: nonEmptyStringValidator
});
